import { BoxProps, Icon } from '@chakra-ui/react'

import LogoIcon from '@/public/assets/brand/logo-36x36.png'
import { Image } from '@/components/HOC/Image'
import {
  INJ_DENOM,
  NBZ_DENOM,
  NBZ_DENOM_BASE,
  NBZ_SDK,
  SHU_DENOM,
  SOL_DENOM,
  SOL_DENOM_BASE,
  USDC_NEW_DENOM,
  USDC_DENOM_BASE,
  USDT_DENOM,
  USDC_DENOM,
} from '@/constants/constants'

import InjLogo from '@/public/assets/images/injective.png'
import UsdtLogo from '@/public/assets/currencies/usdt.svg'
import InjMonoLogo from '@/public/assets/currencies/inj-mono.svg'
import NbzMonoLogo from '@/public/assets/currencies/nbz-mono.svg'
import SolMonoLogo from '@/public/assets/currencies/sol-mono.svg'
import UsdcMonoLogo from '@/public/assets/currencies/usdc-mono.svg'
import UsdcLogo from '@/public/assets/currencies/usdc.svg'
import ShuLogo from '@/public/assets/currencies/shu.png'
import ShuMonoLogo from '@/public/assets/currencies/shu.png'

import SOL from '@/public/assets/tokens/sol.svg'

import { TokenMoney, NbzMetadata, SupportedCurrencies } from '@ninjablaze/sdk-ts'

NbzMetadata.changeEnvironment(NBZ_SDK as any)

export type Token = {
  denom: string
  currency: SupportedCurrencies
  icon: (boxSize?: BoxProps['boxSize']) => React.ReactElement
  iconMono: (boxSize?: BoxProps['boxSize']) => React.ReactElement
  name: string
  decimals: number
  precisions: number

  isActive?: boolean
}

const tokens: Array<Token> = [
  {
    denom: USDC_DENOM,
    currency: SupportedCurrencies.USDC,
    icon: (boxSize = 4) => <Icon as={UsdcLogo} display={'block'} w={boxSize} h={boxSize} />,
    iconMono: (boxSize = 4) => <Icon as={UsdcMonoLogo} w={boxSize} h={boxSize} />,
    name: 'USDC (Noble)',
    decimals: USDC_DENOM_BASE,
    precisions: 2,
    isActive: false,
  },
  {
    denom: USDC_NEW_DENOM,
    currency: SupportedCurrencies.USDC,
    icon: (boxSize = 4) => <Icon as={UsdcLogo} display={'block'} w={boxSize} h={boxSize} />,
    iconMono: (boxSize = 4) => <Icon as={UsdcMonoLogo} w={boxSize} h={boxSize} />,
    name: 'USDC',
    decimals: USDC_DENOM_BASE,
    precisions: 2,
    isActive: true,
  },
  {
    denom: SOL_DENOM,
    currency: SupportedCurrencies.SOL,
    icon: (boxSize = 4) => <Icon w={boxSize} h={boxSize} as={SOL} alt="" />,
    iconMono: (boxSize = 4) => <Icon as={SolMonoLogo} w={boxSize} h={boxSize} />,
    name: 'SOL',
    decimals: SOL_DENOM_BASE,
    precisions: 3,
    isActive: true,
  },
  {
    denom: INJ_DENOM,
    currency: SupportedCurrencies.INJ,
    icon: (boxSize = 4) => <Image w={boxSize} h={boxSize} src={InjLogo} alt={''} />,
    iconMono: (boxSize = 4) => <Icon as={InjMonoLogo} w={boxSize} h={boxSize} />,
    name: 'INJ',
    decimals: 18,
    precisions: 3,
    isActive: true,
  },
  {
    denom: NBZ_DENOM,
    currency: SupportedCurrencies.NBZ,
    icon: (boxSize = 4) => <Image w={boxSize} h={boxSize} src={LogoIcon} alt="" />,
    iconMono: (boxSize = 4) => <Icon as={NbzMonoLogo} w={boxSize} h={boxSize} />,
    name: 'NBZ',
    decimals: NBZ_DENOM_BASE,
    precisions: 2,
    isActive: true,
  },

  {
    denom: SHU_DENOM || '',
    currency: SupportedCurrencies.SHU,
    icon: (boxSize = 4) => <Image w={boxSize} h={boxSize} src={ShuLogo} alt="" />,
    iconMono: (boxSize = 4) => <Image w={boxSize} h={boxSize} src={ShuMonoLogo} alt="" />,
    name: 'SHU',
    decimals: 6,
    precisions: 0,
    isActive: true,
  },

  {
    denom: USDT_DENOM || '',
    currency: SupportedCurrencies.USDT,
    icon: (boxSize = 4) => <Icon as={UsdtLogo} w={boxSize} h={boxSize} />,
    iconMono: (boxSize = 4) => <Icon as={UsdtLogo} w={boxSize} h={boxSize} />,
    name: 'USDT',
    decimals: 6,
    precisions: 2,

    isActive: false,
  },
]

const tokensByDenom = Object.fromEntries(tokens.map((token) => [token.denom.toLocaleLowerCase(), token]))
const tokensByCurrency = Object.fromEntries(tokens.map((token) => [token.currency.toLocaleLowerCase(), token]))

export const allTokenDenom = tokens.map((token) => token.denom)

export const getTokenByDenom = (denom: string) => tokensByDenom[(denom || 'inj').toLocaleLowerCase()] //TODO remove optional
export const getTokenByCurrency = (currency: SupportedCurrencies) => tokensByCurrency[currency.toLocaleLowerCase()]
export const getTokens = () => tokens.filter((token) => token.isActive)

export class TokenMoneyWithHeight extends TokenMoney {
  private readonly _height: number

  constructor(amount: string | number | BigNumber, denom: string, height: number) {
    super(amount, denom)
    this._height = height
  }

  get height(): number {
    return this._height
  }
}
